import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class DataService {

  constructor(private httpClient: HttpClient) {}

  async getAddresses(query: any, token: any, take: number, filterType: any) {
    const option = {take: take, suggestionTypes: filterType };
    const body = {
      searchCriteria: {
          query
      },
      options: option
    };
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token.apiKey,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      })
    };
    return await this.httpClient.post(token.domainServer, body, httpOptions).toPromise();
  }
}
